import { Clinic } from '../clinic/clinic';

export class Healthgroup {
  constructor(
    public id?: number,
    public name?: string,
    public address?: string,
    public county?: string,
    public city?: string,
    public phone?: string,
    public clinics?: Clinic[]
  ) {}
}
